// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar-module--navbar--3j61P","navbarMenuItemsContainer":"Navbar-module--navbar-menu-items-container--2WqHB","navbarMenuItem":"Navbar-module--navbar-menu-item--30zrz"};